import type React from "react";
import type { ActionReportItem } from "../../../../services/GroupManagementOverview/groupManagementOverviewAPI.types";
import { WhosNewCard } from "./WhosNew/WhosNew";
import { WhosCloseCard } from "./WhosClose/WhosClose";
import { RenewalsCard } from "./Renewals/Renewals";
import { BronzeGroupTrackingCard } from "./BronzeGroupTracking/BronzeGroupTracking";
import { SSIUplineCard } from "./SSIUpline/SSIUpline";
import { BirthdaysCard } from "./Birthdays/Birthdays";
import { NonBonusableBvCard } from "./NonBonusableBv/NonBonusableBv";
import { CbrClockCheckCard } from "./CbrClockCheck/CbrClockCheck";
import { IboOnboardingCard } from "./IboOnboarding/IboOnboarding";
import { CvrComplianceCard } from "./CvrCompliance/CvrCompliance";
import { SaqCertificationCard } from "./SaqCertification/SaqCertification";
import { FsiActionReportCard } from "./FsiActionReport/FsiActionReportCard";
import { GroupSopTrackingCard } from "./GroupSopTracking/GroupSopTracking";
export type CardComponentProps = {
  enabled: boolean;
};
type CardComponent = React.ComponentType<CardComponentProps>;

const ACTION_CARD_REGISTRY: Record<string, CardComponent> = {
  whosNew: WhosNewCard,
  ssiUplineReport: SSIUplineCard,
  bronzeGroupTracking: BronzeGroupTrackingCard,
  whosClose: WhosCloseCard,
  birthdays: BirthdaysCard,
  renewals: RenewalsCard,
  nonBonusableBv: NonBonusableBvCard,
  cbrClockCheck: CbrClockCheckCard,
  iboOnboarding: IboOnboardingCard,
  cvrCompliance: CvrComplianceCard,
  saqCertification: SaqCertificationCard,
  foundersSalesIncentiveReport: FsiActionReportCard,
  groupSopTracking: GroupSopTrackingCard,
};

type ActionCenterProps = {
  items: ActionReportItem[];
};

export const ActionCenter = ({ items }: ActionCenterProps) => (
  <>
    {items.map(({ Id, Enabled }) => {
      const Card = ACTION_CARD_REGISTRY[Id];
      if (!Card) return null;
      return <Card key={Id} enabled={Enabled} />;
    })}
  </>
);
